import { searchFormatter } from '../../ts/utils/formatters.ts';
import { findProvider } from '../../ts/service/link-to-inbox-service.ts';
import { JtagService } from '../../ts/service/jtag-service.ts';
import { manageSubscriptionPopupVisibilityInJPP } from '../../ts/service/subscription-popup-service.ts';
import { openTab } from '../../ts/utils/open-tab.ts';
import { getDomain } from '../../ts/service/email-service.ts';
import { subscribeJobseeker } from '../../ts/service/xhr-service.ts';
import { pushEvent } from '../../ts/service/gtm-service.ts';

angular
  .module('jrSerpAdvert', ['jrConfig', 'jrInlineProposal', 'jrEvents'])
  .value('searchFormatter', searchFormatter)
  .value('findProvider', findProvider)
  .value('manageSubscriptionPopupVisibilityInJPP', manageSubscriptionPopupVisibilityInJPP)
  .value('openTab', openTab)
  .directive('jrAdvert', [
    'InlineProposalConfig',
    'PagesConfig',
    'SearchConfig',
    'EventsService',
    'inlineProposalDataService',
    'SearchFormService',
    'JobseekerConfig',
    '$compile',
    '$rootScope',
    'Messages',
    'searchFormatter',
    'findProvider',
    'manageSubscriptionPopupVisibilityInJPP',
    'openTab',
    function (
      InlineProposalConfig,
      PagesConfig,
      SearchConfig,
      EventsService,
      inlineProposalDataService,
      SearchFormService,
      JobseekerConfig,
      $compile,
      $rootScope,
      Messages,
      searchFormatter,
      findProvider,
      manageSubscriptionPopupVisibilityInJPP,
      openTab
    ) {
      return {
        scope: true,
        link(scope, element, attrs) {
          function openAdvert(target, url, tracking) {
            if (element.parent().hasClass('result-list') && tracking) {
              if (scope.advert.isSponsored === false || scope.advert.isSponsored === null) {
                dataLayer.push({
                  event: 'advertClickout',
                  visitType: scope.advert.actionType,
                  page: PagesConfig.pageNum,
                  pos: scope.advert.advertPosition,
                  website: scope.advert.website,
                  advert: scope.advert,
                });
              }
            }
            openTab(
              url,
              target,
              scope.advert.enumAdvertType === 'SPONSORED' ||
                scope.advert.enumAdvertType === 'PROMOTED'
            );
          }

          scope.jobseeker = {};
          scope.messages = Messages;
          scope.advert = angular.isDefined(attrs.advert) ? scope.$eval(attrs.advert) : {};
          scope.advertPosition = angular.isDefined(attrs.position) ? attrs.position : 0;
          scope.productType = angular.isDefined(attrs.productType) ? attrs.productType : '';
          scope.proposalVisible = false;
          scope.proposalSubscriptionSentVisible = false;
          scope.hasBeenSubmitted = false;
          scope.search = SearchConfig;
          scope.isMobile = jrConfigGlobal.isMobile;
          scope.isDesktop = jrConfigGlobal.isDesktop;
          scope.skipTarget =
            scope.isMobile || jrConfigGlobal.feature.interstitialAdsEnabled ? '_self' : '_blank';
          scope.jobseeker.email = JobseekerConfig.email || '';
          scope.captchaEnabled = SearchConfig.isSubscriptionCaptchaEnabled;
          scope.captchaUserResponse = '';
          scope.inlineProposalBackgroundYellowEnabled =
            jrConfigGlobal.feature.inlineProposalBackgroundYellowEnabled;
          scope.searchLabel = searchFormatter({
            what: SearchFormService.search.what,
            where: SearchFormService.search.where,
            rewrittenWhere: SearchFormService.search.rewrittenWhere,
            distance: SearchFormService.search.distance,
          });
          let areTemplatesGenerated = false;

          EventsService.on.subscriptionSent(function (e, data) {
            scope.jobseeker.email = data.email;
            scope.$digest();
          });

          EventsService.on.singleOptInSubscriptionConfirmed(function (event, data) {
            scope.jobseeker.email = data.email;
            scope.$digest();
          });

          // Open proposal
          scope.advertClick = function (e, type) {
            e.preventDefault();

            JtagService.trackAdvertClick({
              id: scope.advert.advertId,
              display_location: scope.advert.locations
                ? scope.advert.locations.join('$')
                : scope.advert.location,
              type: scope.advert.enumAdvertType,
              position: scope.advertPosition,
              product_type: scope.productType,
            });

            const advertType = type ? type.toLocaleLowerCase() : '';

            if (
              scope.isDesktop &&
              advertType === 'organic' &&
              !jrConfigGlobal.feature.interstitialAdsEnabled
            ) {
              e.target.target = '_blank';
            }

            if (jrConfigGlobal.feature.interstitialAdsEnabled) {
              manageSubscriptionPopupVisibilityInJPP(scope.advert.enumAdvertType);
            }

            if (
              scope.jobseeker.email === '' &&
              inlineProposalDataService.inlineProposalEnabled &&
              type !== 'indeed' &&
              (InlineProposalConfig.advertTypeWithInlineProposal === 'all' ||
                InlineProposalConfig.advertTypeWithInlineProposal === advertType)
            ) {
              // Deactivate others and store this scope
              inlineProposalDataService.deactivatePrevious();
              inlineProposalDataService.storeActivatedProposal(scope);
              // Activating inline proposal
              scope.activateProposal();
              // Emitting subscription proposal
              EventsService.emit.subscriptionProposal({
                type: 'inline',
              });

              JtagService.trackSubscriptionProposal('inline');

              if (scope.isDesktop && (advertType === 'sponsored' || advertType === 'promoted')) {
                openAdvert(e.target.target, scope.advert.openAdvertUrl, true);
              }
            } else {
              // Deactivate others
              inlineProposalDataService.deactivatePrevious();
              openAdvert(e.target.target, scope.advert.openAdvertUrl, true);
            }
          };

          scope.activateProposal = function () {
            if (!areTemplatesGenerated) {
              if (jrConfigGlobal.feature.confirmationSingleClickEnabled) {
                element.append($compile(angular.element('<x-jr-inline-proposal-form/>'))(scope));
              } else {
                element
                  .append($compile(angular.element('<x-jr-inline-proposal-form/>'))(scope))
                  .append(
                    $compile(angular.element('<x-jr-inline-proposal-subscription-sent/>'))(scope)
                  );
              }
              areTemplatesGenerated = true;
            }
            // Emitting proposal activation
            EventsService.emit.inlineProposalActivated();
            // Change visibility
            scope.proposalVisible = true;
            scope.proposalSubscriptionSentVisible = false;
          };

          scope.deactivateProposal = function () {
            // Resetting form
            scope.forms.inlineProposal.$setPristine();
            scope.jobseeker.email = '';
            scope.hasBeenSubmitted = false;
            // Emitting proposal deactivation
            EventsService.emit.inlineProposalDeactivated();
            // Change visibility
            scope.proposalVisible = false;
            scope.proposalSubscriptionSentVisible = false;
          };

          scope.skipProposal = function (e) {
            e.preventDefault();
            scope.closeProposal(e);
            openAdvert(e.target.target, e.target.href, true);
          };

          scope.closeProposal = function (e) {
            scope.proposalVisible = false;
            scope.proposalSubscriptionSentVisible = false;
          };

          const afterProposalSubmit = (result) => {
            const { status } = result;
            const created = status >= 200 && status < 300;
            pushEvent({
              event: 'jobseekerCreate',
              created,
              subscriberUid: result.headers.get('subscriberUid'),
              subscriptionConversionValue: parseFloat(
                result.headers.get('subscriptionConversionValue') || '0'
              ),
            });

            if (status === 201 || status === 409) {
              EventsService.emit.subscriptionSent({
                type: 'inline',
                email: scope.jobseeker.email,
              });
              JtagService.trackSubscription('inline', getDomain(scope.jobseeker.email) || '');

              if (jrConfigGlobal.feature.confirmationSingleClickEnabled) {
                if (jrConfigGlobal.feature.singleOptInWelcomePopupEnabled) {
                  const url = [];
                  const emailProviders = findProvider(scope.jobseeker.email);

                  url.push(`email=${encodeURIComponent(scope.jobseeker.email)}`);
                  if (emailProviders.length) {
                    url.push(`linkToInboxProviderUrl=${encodeURIComponent(emailProviders[0].url)}`);
                  }

                  scope.advert.openAdvertUrl += `&${url.join('&')}`;
                }

                JtagService.trackConfirmation('single_opt_in');

                if (!jrConfigGlobal.isMobile) {
                  setTimeout(() => {
                    window.location.reload();
                  });
                }
              }
              openAdvert(scope.skipTarget, scope.advert.openAdvertUrl, true);
            } else if (scope.captchaEnabled) {
              grecaptcha.reset($rootScope.inlineProposalCaptcha);
            }
          };

          const registerJobseeker = async () => {
            // Dectivating inline proposal
            scope.activateProposalSubscriptionSent();
            // Removing open advert prevention
            inlineProposalDataService.inlineProposalEnabled = false;

            const response = await subscribeJobseeker({
              email: scope.jobseeker.email,
              what: SearchFormService.search.what,
              where: SearchFormService.search.where,
              captchaResponse: scope.captchaUserResponse,
            });
            afterProposalSubmit(response);
          };

          scope.handleCaptchaError = () => {
            scope.hasBeenSubmitted = false;
            grecaptcha.reset($rootScope.inlineProposalCaptcha);
          };

          scope.handleCaptchaCallback = async (response) => {
            if (response) {
              scope.captchaUserResponse = response;
              await registerJobseeker();
            } else {
              scope.handleCaptchaError();
            }
          };

          scope.proposalSubmit = async function (e) {
            e.preventDefault();
            scope.hasBeenSubmitted = true;

            if (!scope.forms.inlineProposal.$valid) {
              scope.hasBeenSubmitted = true;
              return;
            }
            if (scope.captchaEnabled && $rootScope.inlineProposalCaptcha !== -1) {
              grecaptcha.ready(() => {
                grecaptcha.execute($rootScope.inlineProposalCaptcha);
              });
            } else {
              await registerJobseeker();
            }
          };

          scope.activateProposalSubscriptionSent = function () {
            // Change visibility
            scope.proposalVisible = false;
            scope.proposalSubscriptionSentVisible = true;
          };

          scope.openIndeedAdvert = function (event) {
            event.preventDefault();

            JtagService.trackAdvertClick({
              id: scope.advert.advertId,
              display_location: scope.advert.locations
                ? scope.advert.locations.join('$')
                : scope.advert.location,
              type: scope.advert.enumAdvertType,
              position: scope.advertPosition,
              product_type: scope.productType,
            });

            openTab(
              event.target.href,
              event.target.target,
              scope.advert.enumAdvertType === 'SPONSORED' ||
                scope.advert.enumAdvertType === 'PROMOTED'
            );
          };
        },
      };
    },
  ]);
